import { type ProductizedServiceCardDataWrapper$key } from '#app/__generated__/relay/ProductizedServiceCardDataWrapper.graphql.js';
import { type Sortable } from '#app/components/SortableListView/types.js';
import { ProductizedServiceCard } from './ProductizedServiceCard.js';
import { graphql, useFragment } from '@contra/relay';

type ProductizedServiceCardDataWrapperProps = Sortable & {
  readonly canEdit: boolean;
  readonly isLastElement: boolean;
  readonly openInNewWindow?: boolean;
  readonly position: number;
  readonly productizedService: ProductizedServiceCardDataWrapper$key;
  readonly rolesSortFunction?: (
    a: { name: string },
    b: { name: string },
  ) => number;
  readonly tagOverflowMenuPlacement?: 'bottom' | 'left' | 'right' | 'top';
  readonly toolsSortFunction?: (
    a: { name: string },
    b: { name: string },
  ) => number;
};

export const ProductizedServiceCardDataWrapper = (
  props: ProductizedServiceCardDataWrapperProps,
) => {
  const service = useFragment<ProductizedServiceCardDataWrapper$key>(
    graphql`
      fragment ProductizedServiceCardDataWrapper on ProductizedService {
        id
        analyticsId
        slug
        price {
          amount
          interval
          timeline
          type
        }
        title
        userProfile {
          analyticsId
        }
        visitorCanEdit
        llmSuggestionId
        publishedAt
        roles {
          edges {
            node {
              id
              name
            }
          }
        }
        tools {
          edges {
            node {
              id
              name
            }
          }
        }
        portfolioProjects {
          edges {
            node {
              id
              title
              slug
              cover {
                ... on PortfolioProjectImageCover {
                  image {
                    uid
                  }
                }

                ... on PortfolioProjectTextCover {
                  style
                }
              }
            }
          }
        }
      }
    `,
    props.productizedService,
  );

  return (
    <ProductizedServiceCard
      {...props}
      service={service}
    />
  );
};
